import { IAddress } from 'bg-server/src/components/api/v1/address/types';

import { ENV } from 'src/config/environments';
import { httpRequest } from 'src/helpers/http';

class AddressService {
    private getApiEndpoint(): string {
        const selectedCity = localStorage.getItem('selectedCity') || ENV.apiEndpoints[0].key;
        const apiEndpoint = ENV.apiEndpoints.find(endpoint => endpoint.key === selectedCity);
        return apiEndpoint ? `${apiEndpoint.url}/address` : `${ENV.apiEndpoints[0].url}/address`;
    }

    public async search(query: string): Promise<IAddress[]> {
        const response = await httpRequest(`${this.getApiEndpoint()}/search?query=${query}`, 'GET');
        const json = await response.json();
        if (json.error !== undefined) {
            await Promise.reject(json.message);
        }
        return json;
    }

    public async getOptions(): Promise<{
        districtes: string[],
        barris: string[],
        codiPostals: string[],
    }> {
        const response = await httpRequest(`${this.getApiEndpoint()}/options`, 'GET');
        const json = await response.json();
        if (json.error !== undefined) {
            await Promise.reject(json.message);
        }
        return json;
    }
}

export const addressService = new AddressService();
